var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 18.6667C15.0628 18.6667 19.1668 14.5626 19.1668 9.5C19.1668 4.43739 15.0628 0.333332 10.0002 0.333332C4.93755 0.333332 0.833496 4.43739 0.833496 9.5C0.833496 14.5626 4.93755 18.6667 10.0002 18.6667ZM10.0002 16.9943C5.86117 16.9943 2.50585 13.639 2.50585 9.5C2.50585 5.64268 5.42002 2.46601 9.16683 2.0515V9.15482C9.16683 9.59685 9.34242 10.0208 9.65498 10.3333L14.6775 15.3559C13.3955 16.3812 11.7694 16.9943 10.0002 16.9943ZM15.856 14.1774L12.2965 10.6178C12.1915 10.5129 12.2659 10.3333 12.4144 10.3333H17.4487C17.2888 11.7783 16.7181 13.0994 15.856 14.1774ZM17.4487 8.66666H11.2502C11.02 8.66666 10.8335 8.48012 10.8335 8.25V2.0515C14.3067 2.43574 17.0644 5.19346 17.4487 8.66666Z",
    fill: "#D80587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartWhite);
export default __webpack_public_path__ + "static/media/pie-chart-white.571b4d7545220c085df04f0e5a3e2c95.svg";
export { ForwardRef as ReactComponent };